import { render, staticRenderFns } from "./Podium.vue?vue&type=template&id=1c8bf674&scoped=true"
import script from "./Podium.vue?vue&type=script&lang=js"
export * from "./Podium.vue?vue&type=script&lang=js"
import style0 from "./Podium.vue?vue&type=style&index=0&id=1c8bf674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8bf674",
  null
  
)

export default component.exports